import { FILIERES, PARTNER, STRUCTURE_OPTIONS, SUBJECT_OPTIONS } from "@/lib/content";

const name = { name: "name", label: "Nom complet", required: true };
const email = { name: "email", label: "E-mail", type: "email", required: true };
const phone = { name: "phone", label: "Téléphone (format international)", type: "tel" };
const country = { name: "country", label: "Pays", type: "country", required: true };
const structure = { name: "structure", label: "Structure concernée", type: "select", options: STRUCTURE_OPTIONS, required: true };
const message = { name: "message", label: "Message", type: "textarea" };

export const CONTACT_FIELDS = [name, email, phone, country, structure,
  { name: "subject", label: "Objet", type: "select", options: SUBJECT_OPTIONS, required: true },
  { ...message, required: true }];

export const VOLUNTEER_FIELDS = [name, email, phone, country, structure,
  { name: "skills", label: "Compétences / profession", detail: true, full: true },
  { name: "availability", label: "Disponibilité", type: "select", detail: true, required: true,
    options: [["Ponctuelle", "Ponctuelle"], ["Régulière", "Régulière"], ["Mission sur place", "Mission sur place"], ["À distance", "À distance"]] },
  { ...message, label: "Motivation" }];

export const DONATION_FIELDS = [name, email, phone, country, structure,
  { name: "don_type", label: "Type de don", type: "select", detail: true, required: true,
    options: ["Matériel médical et fournitures", "Matériel agricole", "Matériel informatique", "Panneaux solaires / électricité",
      "Matériel de formation / atelier", "Vêtements et textile", "Fournitures scolaires", "Autre"].map((o) => [o, o]) },
  { name: "description", label: "Description du don (nature, quantité, état)", type: "textarea", detail: true, required: true, rows: 4 },
  { ...message, label: "Informations complémentaires (acheminement, disponibilité…)", rows: 3 }];

export const PARTNER_FIELDS = [
  { name: "organisation", label: "Organisation", detail: true, required: true },
  { name: "org_type", label: "Type de structure", type: "select", detail: true, required: true,
    options: ["ONG", "Association", "Fondation", "Entreprise", "Institution", "Bailleur", "Donateur individuel"].map((o) => [o, o]) },
  { ...name, label: "Nom du contact" }, email, phone, country, structure,
  { name: "domains", label: "Domaines de partenariat souhaités", type: "checkboxes", options: PARTNER.domains, detail: true, required: true },
  { ...message, label: "Présentation de votre projet de partenariat" }];

export const TRAINING_FIELDS = [
  name,
  { name: "age", label: "Âge", type: "number", min: 10, max: 100, detail: true, required: true },
  { ...phone, required: true },
  { name: "email", label: "E-mail (facultatif)", type: "email" },
  { name: "filiere", label: "Filière choisie", type: "select", detail: true, required: true, full: true, options: FILIERES.map((f) => [f.title, f.title]) },
  { name: "situation", label: "Situation", type: "select", detail: true, required: true, full: true,
    options: ["Jeune sans moyens", "Personne en situation de handicap", "Personne vulnérable", "Personne âgée", "Étudiant(e) / élève", "Sans emploi", "En activité", "Autre"].map((o) => [o, o]),
    hint: "Ne mentionnez aucune information médicale." },
  { ...message, label: "Message / motivation" }];
